import React from 'react';
import SettingsAdminDashboard from '../Settings/AdminDashboard';

/**
 * Dashboard admin — réutilise le composant Settings/AdminDashboard
 * Enveloppé dans un fond clair pour respecter la palette de couleurs
 * du composant (conçu pour thème light : text-gray-900, bg-white, etc.)
 */
const AdminDashboard: React.FC = () => (
  <div className="p-4 min-h-full">
    <div className="bg-gray-50 rounded-2xl overflow-hidden">
      <SettingsAdminDashboard />
    </div>
  </div>
);

export default AdminDashboard;
